module.exports = __webpack_public_path__ + "static/img/poster.8f8e2039.jpg";